export const getLocalStorageUser = () => {
  const userOriginal = localStorage.getItem("user");
  const user = userOriginal && JSON.parse(userOriginal);
  return user;
};

export const getLocalStorageTerms = () => {
  const termsAgreeOriginal = localStorage.getItem("termsAgree");
  const termsAgree = termsAgreeOriginal && JSON.parse(termsAgreeOriginal);
  return termsAgree;
};

export const getLocalStorageItems = (itemName: string) => {
  const itemOriginal = localStorage.getItem(itemName);
  const item = itemOriginal && JSON.parse(itemOriginal);
  return item;
};
